import { useMutation } from '@tanstack/react-query';
import { get } from '../../utils/networking';

interface TeamsOAuthInitiateResponse {
  authorizationUrl: string;
  state: string;
}

interface TeamsOAuthInitiateParams {
  teamId: number;
}

const initiateTeamsOAuth = async (params: TeamsOAuthInitiateParams): Promise<TeamsOAuthInitiateResponse> => {
  return get<TeamsOAuthInitiateResponse>(
    `/api/integrations/teams/auth/initiate?teamId=${params.teamId}`,
  );
};

export const useInitiateTeamsOAuth = () => {
  return useMutation({
    mutationFn: initiateTeamsOAuth,
  });
};
